<template>
    <el-dialog :title="titleName" :visible.sync="dialogFormVisible" width="55%">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业名称" :label-width="formLabelWidth" :required="true" prop="qymc">
                        <el-input v-model="form.qymc" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">

                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="启用年份" :label-width="formLabelWidth" :required="true" prop="qyYear">
                        <el-date-picker
                                style="width: 100%"
                                v-model="form.qyYear"
                                :disabled="!form.canEditOther"
                                type="year"
                                value-format="yyyy"
                                placeholder="选择年">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="启用月份" :label-width="formLabelWidth" :required="true" prop="qyMonth">
                        <el-date-picker
                                style="width: 100%"
                                popper-class="monthStyle"
                                v-model="form.qyMonth"
                                :disabled="!form.canEditOther"
                                type="month"
                                format="MM"
                                value-format="MM"
                                placeholder="选择月">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="本位币种" :label-width="formLabelWidth" :required="true" prop="bwb">
                        <el-input style="width: 100%" :disabled="!form.canEditOther" v-model="form.bwb" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="会计制度" :label-width="formLabelWidth" :required="true" prop="kzzd">
                        <el-select
                                style="width: 100%"
                                v-model="form.kzzd"
                                :disabled="!form.canEditOther"
                                placeholder="会计制度"
                                clearable>
                            <el-option label="小企业会计准则（2013年颁）" value="小企业会计准则（2013年颁）"/>
                            <el-option label="新会计准则（2006年颁）" value="新会计准则（2006年颁）"/>
                            <el-option label="民间非营利组织会计制度" value="民间非营利组织会计制度"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="纳税人名称" :label-width="formLabelWidth">
                        <el-input v-model="form.nsrmc" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="纳税识别号" :label-width="formLabelWidth">
                        <el-input v-model="form.nsrcbh" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                form: {
                    id: '',
                    qymc: '',
                    bwb: 'RMB',
                    qyYear: '',
                    qyMonth: '',
                    kzzd: '',
                    nsrmc: '',
                    nsrcbh: '',
                    userId: '',
                    canEditOther: true
                },
                rules: {
                    id: [{required: true, message: '请输入主键', trigger: 'blur'}],
                    qymc: [{required: true, message: '请输入企业名称', trigger: 'blur'}],
                    bwb: [{required: true, message: '请输入本位币', trigger: 'blur'}],
                    qyYear: [{required: true, message: '请输入启用年份', trigger: 'blur'}],
                    qyMonth: [{required: true, message: '请输入启用月份', trigger: 'blur'}],
                    kzzd: [{required: true, message: '请输入会计制度', trigger: 'blur'}],
                    nsrmc: [{required: true, message: '请输入纳税人名称', trigger: 'blur'}],
                    nsrcbh: [{required: true, message: '请输入纳税人识别号', trigger: 'blur'}],
                    userId: [{required: true, message: '请输入用户ID', trigger: 'blur'}]
                },
                formLabelWidth: '90px'
            };
        },
        methods: {
            int(id) {

                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.qymc = '';
                this.form.bwb = 'RMB';
                this.form.qyYear = '';
                this.form.qyMonth = '';
                this.form.kzzd = '';
                this.form.nsrmc = '';
                this.form.nsrcbh = '';
                this.form.userId = '';
                this.form.canEditOther = true;

                if (id == 'add') {
                    this.titleName = "新增账套";
                    this.url = "/business/zhangTao/save";
                } else {
                    this.titleName = "修改账套";
                    this.url = "/business/zhangTao/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/zhangTao/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
